import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { TableHead, TableRow, TableCell, Table, IconButton, Checkbox } from "@mui/material";
import { BoldCell } from "components/common/TableStyles";
import { Check } from "@mui/icons-material";

const PartnerAssociationSelectionComponent = ({ partnerData, handleAssociate, isSingleSelection }) => {
  const { t } = useTranslation();
  return (
    <Table>
      <TableHead>
        <TableRow>
          <BoldCell>{t("Partner.Name")}</BoldCell>
          <BoldCell>{t("Partner.UniqueID")}</BoldCell>
          <BoldCell>{t("Partner.PartnerType")}</BoldCell>
          <BoldCell>{t("Actions")}</BoldCell>
        </TableRow>
      </TableHead>
      {partnerData?.map(item => {
        return (
          <TableRow key={item.id}>
            <TableCell>{item.partnerName}</TableCell>
            <TableCell>{item.uniqueId}</TableCell>
            <TableCell>{item.partnerTypeName}</TableCell>
            <TableCell>
              {isSingleSelection ? (
                <IconButton onClick={() => handleAssociate(item.id, null)}>
                  <Check />
                </IconButton>
              ) : (
                <Checkbox onChange={event => handleAssociate(item.id, event.target.checked)} />
              )}
            </TableCell>
          </TableRow>
        );
      })}
    </Table>
  );
};

PartnerAssociationSelectionComponent.propTypes = {
  partnerData: PropTypes.array.isRequired,
  handleAssociate: PropTypes.func.isRequired,
  isSingleSelection: PropTypes.bool.isRequired
};

export default PartnerAssociationSelectionComponent;
